import { Component } from '@verndale/core';
import { LoadSequence } from '../helpers/animations';

class CaseStudy extends Component {
  setupDefaults() {
    this.dom = {
      intro: this.el.querySelector<HTMLElement>('.case-study-intro'),
      card: this.el.querySelector<HTMLElement>('.case-study-card'),
      iconCards: this.el.querySelectorAll('.case-study-icon-card')
    };
    this.loadAnimation();
  }

  loadAnimation() {
    const intro = {
      eyebrow: (this.dom.intro as HTMLElement).querySelector('.eyebrow'),
      title: (this.dom.intro as HTMLElement).querySelector('.module-header__title'),
      description: (this.dom.intro as HTMLElement).querySelector('.module-header__description'),
      buttonsContainer: (this.dom.intro as HTMLElement).querySelector('.module-header__buttons')
    };

    const card = {
      eyebrow: (this.dom.card as HTMLElement).querySelector('.eyebrow'),
      title: (this.dom.card as HTMLElement).querySelector('.case-study-card__title'),
      description: (this.dom.card as HTMLElement).querySelector('.case-study-card__description'),
      buttonsContainer: (this.dom.card as HTMLElement).querySelector('.case-study-card__buttons')
    };

    const iconCards = Array.from(this.dom.iconCards as NodeList) as HTMLElement[];

    const iconCardsObjects: {
      element: HTMLElement;
      addScale: boolean | null;
      offset?: string | number | undefined;
    }[] = iconCards.map((card, index) => ({
      element: card,
      addScale: false,
      offset: 0.1 * index + 1
    }));

    LoadSequence(this.el, [
      { element: intro.eyebrow as HTMLElement, addScale: false, offset: 0 },
      { element: intro.title as HTMLElement, addScale: false, offset: 0.2 },
      { element: intro.description as HTMLElement, addScale: false, offset: 0.4 },
      { element: intro.buttonsContainer as HTMLElement, addScale: false, offset: 0.6 },
      { element: this.dom.card as HTMLElement, addScale: false, offset: 0.6 },
      { element: card.eyebrow as HTMLElement, addScale: false, offset: 0.7 },
      { element: card.title as HTMLElement, addScale: false, offset: 0.8 },
      { element: card.description as HTMLElement, addScale: false, offset: 0.8 },
      { element: card.buttonsContainer as HTMLElement, addScale: false, offset: 1 },
      ...iconCardsObjects
    ]);
  }
}

export default CaseStudy;
